import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'
import * as utils from '../../utils/utils'
import { FunctionsContext } from './FunctionsContext'
import { FunctionsLoginContext } from './FunctionsLoginContext'
import PropTypes from 'prop-types';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import Pagination from '@mui/material/Pagination';
//import AudiotrackIcon from '@mui/icons-material/Audiotrack';
//import MovieIcon from '@mui/icons-material/Movie';
import SvgIcon from '@mui/material/SvgIcon';
import { visuallyHidden } from '@mui/utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CONFIG, PAGES } from '../../utils/Config';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'track',
    numeric: false,
    disablePadding: true,
    label: 'Versions',
    showDesktop: true,
    showMobile: true,
    sourceHide: ["idj"],
  },
  {
    id: 'artist',
    numeric: true,
    disablePadding: false,
    label: 'Artist',
    showDesktop: true,
    showMobile: false,
    sourceHide: [],
  },
  {
    id: 'title',
    numeric: true,
    disablePadding: false,
    label: 'Title',
    showDesktop: true,
    showMobile: false,
    sourceHide: [],
  },
  {
    id: 'title-artist',
    numeric: true,
    disablePadding: false,
    label: 'Artist & Title',
    showDesktop: false,
    showMobile: true,
    sourceHide: [],
  },
  {
    id: 'bpm',
    numeric: true,
    disablePadding: false,
    label: 'BPM',
    showDesktop: true,
    showMobile: false,
    sourceHide: [],
  },
  {
    id: 'genre',
    numeric: true,
    disablePadding: false,
    label: 'Genre',
    showDesktop: true,
    showMobile: false,
    sourceHide: [],
  },
  {
    id: 'year',
    numeric: true,
    disablePadding: false,
    label: 'Year',
    showDesktop: true,
    showMobile: false,
    sourceHide: [],
  },
  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: 'Date',
    showDesktop: true,
    showMobile: false,
    sourceHide: [],
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, desktop } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          (((desktop && headCell.showDesktop) || (!desktop && headCell.showMobile))) &&
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            className="text-center"
            sx={{ padding: { lg: 2, xs: 1 } }} // * 8
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {!headCell.sourceHide.includes(props.source) ? headCell.label : ''}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  onRequestSort: PropTypes.func.isRequired,
};



export default function EnhancedTable(props) {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [pageNum, setPageNum] = React.useState(0);

  let functionsContext = React.useContext(FunctionsContext);
  const functionsLoginContext = React.useContext(FunctionsLoginContext);

  const desktop = useMediaQuery('(min-width:600px)');
  useEffect(() => {
    if (CONFIG.PAGE_START_INDEX === 0) {
      setPageNum(props.pageNum);
    }
    else {
      setPageNum(props.pageNum - 1);
    }
  }, [props.pageNum])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    if (props.currentPage === PAGES.CRATE.name) {
      setPageNum(newPage);
      utils.scrollToTop();
    }
    else {
      if (CONFIG.PAGE_START_INDEX === 0) {
        functionsContext.updatePage(newPage);
      }
      else {
        functionsContext.updatePage(newPage + 1);
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    let count = parseInt(event.target.value, 10);
    functionsContext.updateRowsCount(count);
    setPageNum(0);
  };

  const emptyTable = (rowsCount) => {
    let emptySkelation = [];
    for (let i = 0; i < rowsCount; i++) {
      let row = <TableRow key={i}>{
        headCells.filter(hCell => (hCell.showDesktop === desktop) || (hCell.showMobile !== desktop))
          .map((col) => (<TableCell key={col.id}><Skeleton /></TableCell>))
      }</TableRow>;
      emptySkelation.push(row);
    }
    return emptySkelation;
  }
  const commonSubsequence = (array) => {
    let sortedArray = array.sort();
    let first = sortedArray[0];
    let last = sortedArray.pop();
    let length = first ? first.length : 0;
    let index = 0;

    while (index < length && first[index] === last[index])
      index++;
    return first.substring(0, index);
  }

  const findGroupTitle = (row) => {
    let common = row.media[0].title;
    if (row.media[0].advisory !== '' && !common.includes(row.media[0].advisory)
      && !common.includes('(Radio)') && !common.includes('(Radio Edit)')) {
      common += ` (${row.media[0].advisory})`;
    }
    if (row.media.length > 1) {
      let titlesArr = [];
      row.media.forEach(element => {
        titlesArr.push(element.title);
      });
      common = commonSubsequence(titlesArr)
        //.replaceAll('(', '')
        //.replaceAll(')', '')
        .replaceAll('[', '')
        .replaceAll(']', '')
        .trim('')

      if (common.endsWith(' (')) {
        common = common.substring(0, common.length - 2);
      }
      if (common.endsWith(' -')) {
        common = common.substring(0, common.length - 2);
      }
    }

    return common;
  }

  const showAdvisory = (advisory) => {
    let element = advisory;
    if (advisory === 'Clean') {
      element = <Chip label="Clean" color="grey" className='chip-advisory' />;
    }
    else if (advisory === 'Dirty' || advisory === 'Explicit') {
      element = <Chip label="Explicit" color="primary" className='chip-advisory' />;
    }
    else {
      element = <Chip label={advisory} color="grey" className='chip-advisory' />;
    }
    return element;
  }

  const findVersionTitle = (title, groupTitle, advisory) => {
    let mediaTitle = title;
    if (title !== groupTitle) {
      mediaTitle = title.replace(groupTitle, '');
    }
    return mediaTitle;

    /*.replace(' - ', '')
    .replace(' (' + advisory + ')', '')
    .replace('(', '')
    .replace(')', '')
    .replace(' [', '')
    .replace(']', '')
    */
  }

  const findGenreDisplayName = (media) => {
    let displayName = media.genre;
    let genreList = functionsContext.genreList;
    let genre = genreList.find((fGenre) => fGenre.genreId === media.genreId)
    if (genre) {
      displayName = genre.display_name;
    }
    return displayName;
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  let sliceStart = 0;
  let emptyRows = 0;
  if (props.currentPage === PAGES.CRATE.name) {
    sliceStart = pageNum * props.rowsCount;
    emptyRows = pageNum > 0 ? Math.max(0, (1 + pageNum) * props.rowsCount - props.mediaList.length) : 0;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size='medium'
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              desktop={desktop}
              source={props?.mediaList[0]?.media[0]?.source}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
              {props.mediaList.length > 0 ?
                stableSort(props.mediaList, getComparator(order, orderBy))
                  .slice(sliceStart, pageNum * props.rowsCount + props.rowsCount)
                  .map((row, index) => {
                    let isViewedBefore = false;
                    if (props.previewList) {
                      if (row.media.filter(cmedia => props.previewList.includes(cmedia.mediaId)).length > 0) {
                        isViewedBefore = true;
                      }
                    }
                    const labelId = `enhanced-table-checkbox-${index}`;
                    let groupTitle = findGroupTitle(row);
                    let mediaImg = '/img/logo-crateq.png';
                    if (row.media[0].img) {
                      mediaImg = row.media[0].img;
                    }
                    else if (row.media[0].source === 'lnrp') {
                      mediaImg = '/img/logo-lnrp.png';
                    }
                    else if (row.media[0].source === 'idj') {
                      mediaImg = '/img/logo-idj.png';
                    }
                    else if (row.media[0].source === 'lurp') {
                      mediaImg = '/img/logo-lurp.png';
                    }

                    return (
                      <TableRow
                        hover
                        onClick={(e) => { functionsContext.playMedia(row.media[0]) }}
                        selected={isViewedBefore}
                        role="checkbox"
                        aria-checked={false}
                        tabIndex={-1}
                        key={index}
                        style={{
                          cursor: 'pointer'
                        }}
                      >
                        <TableCell
                          component="td"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          {props.loading ? <Skeleton /> :
                            <Container sx={{ display: 'flex', alignItems: 'center', paddingLeft: { xs: '2px' }, paddingRight: { xs: '2px' } }}>
                              {desktop && <Container style={{ backgroundImage: `url('${mediaImg}')` }} className="media-preview"></Container>}
                              <Container className='cont-version-list'>
                                {row.media.map((media) => (
                                  <Container key={media.mediaId} className='cont-version'>
                                    <p className="cont-title">
                                      {media.source != "idj" && findVersionTitle(media.title, groupTitle, media.advisory)}
                                    </p>
                                    <Container className="cont-advisory-controls">
                                      {/*desktop &&*/ showAdvisory(media.advisory)}
                                      <Container className="cont-controls">
                                        {functionsLoginContext.user.token ?
                                          (props.currentPage !== PAGES.CRATE.name) && !props.crateList.includes(media.mediaId) ?
                                          <Tooltip title="Add to queue">
                                            <span> {/* Fix error MUI: You are providing a disabled `button` child to the Tooltip component.*/}
                                              <IconButton onClick={(e) => { e.stopPropagation(); functionsContext.addToQueue(media) }} sx={{ p: 0 }} disabled={props.mediaActionDisabled}>
                                                <AddBoxIcon sx={{ height: 26, width: 26 }} color="secondary" />
                                              </IconButton>
                                            </span>
                                          </Tooltip>
                                          :
                                          <Tooltip title="Remove from queue">
                                            <span> {/* Fix error MUI: You are providing a disabled `button` child to the Tooltip component.*/}
                                              <IconButton onClick={(e) => { e.stopPropagation(); functionsContext.removeFromQueue(media) }} sx={{ p: 0 }} disabled={props.mediaActionDisabled}>
                                                <ClearIcon sx={{ height: 26, width: 26 }} color="error" />
                                              </IconButton>
                                            </span>
                                          </Tooltip>
                                        : null}
                                        {media.video && functionsLoginContext.user.token &&
                                          <Tooltip title="Download Video">
                                            <span> {/* Fix error MUI: You are providing a disabled `button` child to the Tooltip component.*/}
                                              <IconButton onClick={(e) => { e.stopPropagation(); functionsContext.downloadMedia(media, true) }} sx={{ p: 0 }} disabled={props.mediaActionDisabled}>
                                                {/*<MovieIcon sx={{ height: 26, width: 26 }} color="secondary" />*/}
                                                <SvgIcon sx={{ height: 22, width: 22 }} color="secondary">
                                                  <svg viewBox="0 0 512 329.79">
                                                    <path xmlns="http://www.w3.org/2000/svg" d="M 330.34375,-0.20117188 210.78711,-0.140625 C 180.39054,-0.12530149 151.17809,-0.07235345 126.87891,0 H 63.640625 c -2.218299,0 -4.414384,0.12204499 -6.582031,0.35351562 l -3.181641,0.003906 -0.01563,0.003906 -1.091797,0.001953 -1.05664,0.33007813 -0.363282,0.007813 -5.126953,1.75000002 c -0.0115,0.00392 -0.02171,0.0078 -0.0332,0.011719 C 45.833724,2.5862232 45.490384,2.7014614 45.123047,2.8359375 35.133185,5.9569492 26.101889,11.516595 18.759766,18.839844 12.005155,25.606171 6.7433345,33.879296 3.5292969,43.076172 c -0.015164,0.03858 -0.031733,0.07657 -0.046875,0.115234 -0.4850609,1.209583 -0.9482445,2.41578 -1.359375,3.59961 L 1.5292969,48.5 0.57226562,51.185547 0.42382812,51.587891 v 0.01172 l -0.31835937,0.892579 0.009766,7.623046 C 0.04482117,61.326199 0,62.542369 0,63.769531 V 266.0293 c 0,2.32712 0.13632197,4.62547 0.3828125,6.89062 l 0.007813,6.32617 2.9042969,7.20118 c 0.1757785,0.43585 0.3439997,0.81695 0.5175781,1.23632 3.2267685,8.86756 8.368592,16.83735 14.917969,23.38672 7.325073,7.32508 16.402962,12.87879 26.515625,15.96875 0.812061,0.28244 1.646351,0.5629 2.503906,0.8418 1.218271,0.39621 2.253897,0.6564 4.382812,0.8457 0.01807,0.003 0.03663,0.007 0.05469,0.01 0.354217,0.0704 0.659134,0.11222 0.986328,0.16601 3.409665,0.57356 6.903466,0.88672 10.466797,0.88672 H 214.27148 c 3.22513,0.004 6.06902,0.0159 9.2793,0.0195 l 107.39258,0.1211 0.98828,-0.33203 h 0.043 l 0.57812,-0.20899 3.44141,-1.15625 c 1.55235,-0.5219 3.27387,-1.19544 5.04297,-1.93554 9.21312,-3.21144 17.50255,-8.49081 24.2832,-15.27735 0.94776,-0.94775 1.85446,-1.93436 2.74219,-2.93945 0.0424,-0.0477 0.0827,-0.0968 0.125,-0.14453 0.59308,-0.67548 1.17536,-1.36064 1.74023,-2.06055 0.2365,-0.29186 0.46468,-0.58917 0.69532,-0.88477 0.41726,-0.53571 0.828,-1.07611 1.22851,-1.625 0.20387,-0.28016 0.40462,-0.56225 0.60352,-0.8457 0.48513,-0.68772 0.95561,-1.38496 1.41406,-2.0918 0.0477,-0.0745 0.0971,-0.14797 0.14453,-0.22265 5.14164,-7.99893 8.55545,-17.1767 9.69336,-26.95508 0.0922,-0.58622 0.19521,-1.16225 0.27735,-1.75781 0.78178,-5.6688 0.99895,-6.36914 1.9746,-6.36914 1.19232,0 9.51132,3.55178 56.45313,24.11328 26.44777,11.58468 39.37504,17.27002 46.3457,20.18945 l 4.66211,2.06445 c 5.67865,2.49555 12.15401,0.6789 15.7832,-4.01562 0.28118,-0.24294 0.53194,-0.53852 0.75391,-1.00781 0.35662,-0.46103 0.70969,-0.93065 1.05469,-1.44727 0.0531,-0.0796 0.1032,-0.1988 0.15039,-0.38086 l 0.29492,-0.44336 0.2207,-0.29492 v -0.0391 l 0.0762,-0.11328 v -0.18946 -0.21679 -0.33203 -0.4043 l 0.002,-0.81445 c 0.15193,-0.80162 0.23966,-1.60757 0.24414,-2.41016 V 30.400391 c 0,-0.465702 -0.0252,-0.925584 -0.0723,-1.378907 v -2.71289 l -0.24804,-0.359375 v -0.111328 l -0.94336,-1.259766 -0.33789,-0.488281 c -0.003,-0.0054 -0.007,-0.01022 -0.01,-0.01563 -2.24816,-4.118296 -6.61963,-6.914063 -11.63867,-6.914063 -2.28,0 -4.42078,0.569844 -6.30078,1.589844 l -6.54297,3.023438 c -7.46052,3.300838 -20.17491,9.109347 -43.49414,19.824218 -9.33762,4.290512 -16.3239,7.490363 -22.88477,10.492188 -18.52362,8.44983 -27.41294,12.43847 -31.15429,13.958984 -1.28127,0.507709 -2.06197,0.773438 -2.31641,0.773438 -0.63665,0 -0.97586,-0.259233 -1.28516,-1.646485 -0.17686,-1.094491 -0.39674,-2.664117 -0.62109,-4.347656 -0.0613,-0.525653 -0.10994,-0.859602 -0.17969,-1.484375 -0.007,-0.06483 -0.018,-0.126697 -0.0254,-0.191406 -1.16528,-15.53935 -8.12413,-29.712682 -18.68554,-40.283203 l -0.0801,-0.08984 c -7.09952,-7.081073 -15.8497,-12.5417703 -25.53321,-15.7070314 -0.55238,-0.2096021 -1.15082,-0.4170304 -1.72265,-0.625 -0.0964,-0.034275 -0.18844,-0.071404 -0.28516,-0.1054687 l -0.21289,-0.074219 c -0.67323,-0.24196 -1.30648,-0.4878103 -2.00781,-0.7285156 l -2.17969,-0.74804688 -2.08594,-0.734375 h -0.0566 z" id="path3723" />
                                                    <path xmlns="http://www.w3.org/2000/svg" style={{ fill: '#ffffff' }} d="m 186.1938,232.04848 c -5.41932,-5.55989 -22.07212,-22.69653 -37.00622,-38.08142 l -27.1529,-27.97253 2.57502,-2.67622 c 1.41626,-1.47191 6.45585,-6.38083 11.19909,-10.90868 l 8.62407,-8.23247 18.5176,19.16326 c 11.75802,12.168 18.58034,18.8428 18.68949,18.28535 0.0945,-0.48285 -0.47718,-21.11544 -1.2705,-45.8502 -0.79332,-24.73476 -1.36346,-45.051227 -1.26698,-45.147707 0.0965,-0.0965 7.06116,-0.35269 15.47704,-0.56934 l 15.30162,-0.393907 0.32276,4.653307 c 0.33809,4.87419 2.58073,76.994167 2.57335,82.754837 l -0.004,3.32347 9.00352,-9.13954 c 4.95194,-5.02675 13.32108,-13.56445 18.59807,-18.97267 l 9.59455,-9.83314 11.04117,10.63568 c 6.07265,5.84962 10.97461,10.82516 10.89326,11.05675 -0.19107,0.54437 -75.26565,78.01405 -75.60196,78.01405 -0.13987,0 -4.6883,-4.549 -10.10762,-10.10888 z" id="path3743" />
                                                  </svg>
                                                </SvgIcon>
                                              </IconButton>
                                            </span>
                                          </Tooltip>
                                        }
                                        {media.audio && functionsLoginContext.user.token &&
                                          <Tooltip title="Download Audio">
                                            <IconButton onClick={(e) => { e.stopPropagation(); functionsContext.downloadMedia(media, false) }} sx={{ p: 0 }} disabled={props.mediaActionDisabled}>
                                              <span> {/* Fix error MUI: You are providing a disabled `button` child to the Tooltip component.*/}
                                                <SvgIcon sx={{ height: 22, width: 22 }} color="secondary">
                                                  {/* !Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" />
                                                  </svg>
                                                </SvgIcon>
                                              </span>
                                            </IconButton>
                                          </Tooltip>
                                        }
                                        <Tooltip title="Play">
                                          <IconButton onClick={(e) => { e.stopPropagation(); functionsContext.playMedia(media) }} sx={{ p: 0 }} disabled={props.mediaActionDisabled}>
                                            <PlayArrowIcon sx={{ height: 26, width: 26 }} color="secondary" />
                                          </IconButton>
                                        </Tooltip>

                                      </Container>
                                    </Container>
                                  </Container>
                                ))}
                              </Container>
                            </Container>
                          }
                        </TableCell>
                        {!desktop && <TableCell>{props.loading ? <Skeleton /> : <div><span>{row.media[0].artist}</span> <span>{groupTitle}</span></div>}</TableCell>}
                        {desktop && <TableCell>{props.loading ? <Skeleton /> : row.media[0].artist}</TableCell>}
                        {desktop && <TableCell>{props.loading ? <Skeleton /> : groupTitle}</TableCell>}
                        {desktop && <TableCell>{props.loading ? <Skeleton /> : row.media[0].bpm}</TableCell>}
                        {desktop && <TableCell>{props.loading ? <Skeleton /> : <Link to={`${PAGES.GENRES.path}/${row.media[0].genreId}/${functionsContext.genreSlangURL(findGenreDisplayName(row.media[0]))}`} onClick={(e) => { e.stopPropagation(); }}>{findGenreDisplayName(row.media[0])}</Link>}</TableCell>}
                        {desktop && <TableCell>{props.loading ? <Skeleton /> : row.media[0].releaseYear}</TableCell>}
                        {desktop && <TableCell>{props.loading ? <Skeleton /> : row.media[0].date}</TableCell>}
                      </TableRow>
                    );
                  })
                :
                props.loading ? emptyTable(props.rowsCount).map((row) => (row)) : <TableRow><TableCell colSpan={desktop ? 7 : 2} align='center' className="mui--text-display1">No result found</TableCell></TableRow>
              }
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={desktop ? 7 : 2} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {desktop ? <TablePagination
          className='media-table-pagination'
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={props.total}
          rowsPerPage={props.rowsCount}
          page={pageNum}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={(subProps) => {
            const {
              page,
              count,
              rowsPerPage,
              backIconButtonProps,
              nextIconButtonProps,
              showLastButton,
              getItemAriaLabel,
              showFirstButton,
              onPageChange,
              ...restSubProps
            } = subProps;
            return (
              <Pagination count={props.pages} page={pageNum + 1} onChange={(e, pageNum) => handleChangePage(e, pageNum - 1)} />
            );
          }}
        />
          :
          <TablePagination
            className='media-table-pagination'
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={props.total}
            rowsPerPage={props.rowsCount}
            page={pageNum}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      </Paper>
    </Box>
  );
}